import { defineComponent as _defineComponent } from 'vue'
import { onMounted, computed } from "vue";
import { useAppStore } from "@/ts/stores/app";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";
import HamburgerButton from "@/ts/components/elements/hamburger-button.vue";
import LanguageSwitch from "@/ts/components/elements/language-switch.vue";

interface Props {
    centerLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    rightLinks?: Array<{ class: string; target: string; title: string; url: string }>;
    translatedRoutes: { nl?: { relative_url: string; lang: string }; fr?: { relative_url: string; lang: string }; en?: { relative_url: string; lang: string } };
    firstSectionOverlap?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'sticky-header',
  props: {
    centerLinks: { type: Array, required: false },
    rightLinks: { type: Array, required: false },
    translatedRoutes: { type: Object, required: true },
    firstSectionOverlap: { type: Boolean, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const breakpoints = useBreakpoints(breakpointsTailwind);

const showPageLinks = breakpoints.greater("lg");
const showHamburgerButton = breakpoints.smaller("lg");

const appStore = useAppStore();

const props = __props;

function currentlyViewing(url: string): boolean {
    return window.location.href.indexOf(url) >= 0;
}

onMounted(() => {
    let last_known_scroll_position = 0;
    let ticking = false;

    window.addEventListener("scroll", function () {
        last_known_scroll_position = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(function () {
                if (last_known_scroll_position > 50) {
                    appStore.navigation.header.sticky = true;
                } else {
                    appStore.navigation.header.sticky = false;
                }

                ticking = false;
            });

            ticking = true;
        }
    });
});

const lang = computed(() => {
    return document.documentElement.lang;
});

const __returned__ = { breakpoints, showPageLinks, showHamburgerButton, appStore, props, currentlyViewing, lang, HamburgerButton, LanguageSwitch }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})